export default __webpack_public_path__ + "static/media/about.62962558.jpg";